// 导出 对应的不同接口的URL地址
module.exports = {
  domain: {
    // Base_M1_URL: '/API', // 模块一接口地址
    Base_M1_URL: 'https://crmreport.sakura.com.tw/API', // 模块一接口地址
    Base_M2_URL: 'https://crmreport.sakura.com.tw/API', // 模块二接口地址
    Base_M3_URL: 'https://water.sakura.com.tw/Customer/api' // 模块三接口地址
  }
}
